import { EARTHRANGER_DESTINATION_TYPE } from '../common/ObjectTypes';

export const isEarthRangerDestinationType = (name: string): boolean =>
  name === EARTHRANGER_DESTINATION_TYPE;

// The same check by the type's `value` (slug). Both spellings have been seen
// for the EarthRanger runner's slug, so either counts.
const EARTHRANGER_TYPE_VALUES = ['earth_ranger', 'earthranger'];
export const isEarthRangerTypeValue = (value?: string): boolean =>
  !!value && EARTHRANGER_TYPE_VALUES.includes(value);

// "https://gundi-dev.staging.pamdas.org" → "gundi-dev.staging"
// Also handles URLs with paths, e.g. "https://site.pamdas.org/login" → "site"
// Returns the original URL unchanged if it doesn't match the expected pattern
export const extractEarthRangerSiteName = (url: string): string => {
  const match = url.match(/^(https?:\/\/)?([^/]+)\.pamdas\.org(\/.*)?$/);
  if (!match) return '';
  return match[2];
};

// "gundi-dev.staging" → "https://gundi-dev.staging.pamdas.org"
// Also handles user pasting a full URL with path, e.g. "https://site.pamdas.org/login" → "https://site.pamdas.org"
export const constructEarthRangerUrl = (siteName: string): string => {
  const trimmed = siteName.trim();
  if (!trimmed) return '';

  const cleaned = trimmed
    .replace(/^https?:\/\//, '') // strip scheme
    .replace(/\/.*$/, '') // strip path segments (e.g. /login)
    .replace(/\.pamdas.*$/, ''); // strip .pamdas and anything after (handles typos like .pamdas.or, partial suffix)

  const normalized = cleaned.replace(/^\.+|\.+$/g, ''); // strip leading/trailing dots
  if (!normalized) return '';

  return `https://${normalized}.pamdas.org`;
};
